import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowRestaurantsConfirmationCard from './elements/BkFlowRestaurantsConfirmationCard'

import yn from 'yn'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS)) {
  require('../../styles/css/components/restaurants/bk-flow-restaurants-confirmation-cards.css')
}
class BkFlowRestaurantsCards extends Component {

  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    const {
      configData,
      restaurantReservationData,
    } = this.props

    let restaurantConfirmationCards = [],
        restaurantConfirmationCardType = null

    if (restaurantReservationData.confirmations) {
      restaurantConfirmationCardType = restaurantReservationData.confirmations
    }

    // Construct cards, groups and accordions if data meets requirements
    for (let restaurantKey in restaurantConfirmationCardType) {
      const currentRestaurantCard = restaurantConfirmationCardType[restaurantKey]

      if (currentRestaurantCard.id) {
        restaurantConfirmationCards.push(
          <BkFlowRestaurantsConfirmationCard
            key={ 'restaurant-confirmation-' + restaurantKey }
            configData={ configData }
            restaurantCardData={ currentRestaurantCard }
            restaurantKey={ restaurantKey }
          />
        )
      }
    }


    return (
     <div className="bk-flow-confirmation__restaurants">
       <div className="bk-flow-confirmation__restaurants-cards">
        { restaurantConfirmationCards }
       </div>
     </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    configData: state.configData.configuration,
    restaurantReservationData: state.restaurantReservationData
  }
}

export default connect(mapStateToProps, null)(BkFlowRestaurantsCards)



// WEBPACK FOOTER //
// ./src/components/restaurants/BkFlowRestaurantsConfirmationCards.js